import { Line } from "./line";
import { Vector } from "./vector";

// 3             \     5    |     3     /
//                 \        4         /
//                  \       |       /
//                    \     |     /
//                      \   |   /
//                       \  | /
//      ------ 6 ------------------------- 2 --------
//                       /  |  \
//                     /   /|\   \
//                   /      |      \
//                 /        0        \
//               /     7    |    1     \
//             /            |            \
// const constexpr Enum UTurn = 0;
// const constexpr Enum SharpRight = 1;
// const constexpr Enum Right = 2;
// const constexpr Enum SlightRight = 3;
// const constexpr Enum Straight = 4;
// const constexpr Enum SlightLeft = 5;
// const constexpr Enum Left = 6;
// const constexpr Enum SharpLeft = 7;
// const constexpr Enum MaxDirectionModifier = 8;
const modifiers = {
  0: "UTurn",
  1: "SharpRight",
  2: "Right",
  3: "SlightRight",
  4: "Straight",
  5: "SlightLeft",
  6: "Left",
  7: "SharpLeft"
};

export class Turn {
  constructor(from, via, to) {
    if ((from.x && from.y && via.x && via.y && to.x && to.y) == undefined) {
      throw new Error("Incorrect points");
    }

    this._AC = null;
    this._from = from;
    this._via = via;
    this._to = to;
    this._vec_from = new Vector(from.x - via.x, from.y - via.y);
    this._vec_from.length();
    this._vec_from.normalize();
    this._vec_to = new Vector(to.x - via.x, to.y - via.y);
    this._vec_to.length();
    this._vec_to.normalize();

    if (from.x === to.x && from.y === to.y) {
      this._angle_cos = 1;
      this._angle = 0;
    }

    const angle_degree = (this.angle() / Math.PI) * 180;

    if (angle_degree > 0 && angle_degree <= 60) {
      this._modifier = 1;
    } else if (angle_degree > 60 && angle_degree <= 120) {
      this._modifier = 2;
    } else if (angle_degree > 120 && angle_degree <= 180) {
      this._modifier = 3;
    } else if (angle_degree > -60 && angle_degree < 0) {
      this._modifier = 7;
    } else if (angle_degree > -120 && angle_degree <= -60) {
      this._modifier = 6;
    } else if (angle_degree >= -180 && angle_degree < -120) {
      this._modifier = 5;
    }

    const mult = 10000;
    const pi = Math.trunc(Math.PI * mult);
    const angle = Math.abs(Math.trunc(this.angle() * mult));

    if (Math.trunc(angle / 10) % Math.trunc((2 * pi) / 10) === 0) {
      this._modifier = 0;
    } else if (Math.trunc(angle / 10) % Math.trunc(pi / 10) === 0) {
      this._modifier = 4;
    }
  }

  type() {
    return modifiers[this._modifier];
  }

  modifier() {
    return this._modifier;
  }

  vec_from() {
    return this._vec_from;
  }

  vec_to() {
    return this._vec_to;
  }

  from() {
    return this._from;
  }

  via() {
    return this._via;
  }

  to() {
    return this._to;
  }

  angle_cos() {
    if (!this._angle_cos) {
      this._angle_cos = this.dot_product();
    }
    return this._angle_cos;
  }

  angle() {
    if (!this._angle) {
      this._angle = Math.acos(this.angle_cos()) * this.cross_product_sign();
    }
    return this._angle;
  }

  dot_product() {
    if (!this._dot_product) {
      this._dot_product =
        this._vec_from.x() * this._vec_to.x() +
        this._vec_from.y() * this._vec_to.y();
    }
    return this._dot_product;
  }

  cross_product_sign() {
    if (!this._cross_product_sight) {
      if (
        this._vec_from.x() * this._vec_to.y() -
          this._vec_from.y() * this._vec_to.x() >
        0
      ) {
        this._cross_product_sight = 1;
      } else {
        this._cross_product_sight = -1;
      }
    }
    return this._cross_product_sight;
  }

  bisector_vec() {
    if (!this._bisector_vec) {
      if (this._modifier === 0) {
        this._bisector_vec = new Vector(
          this.from_line()
            .normal_vector()
            .x(),
          this.from_line()
            .normal_vector()
            .y()
        ).reverse();
      } else if (this._modifier === 4) {
        this._bisector_vec = new Vector(
          this.from_line()
            .normal_vector()
            .x(),
          this.from_line()
            .normal_vector()
            .y()
        );
      } else {
        this._bisector_vec = this._vec_from.get_rotated(
          null,
          this.sin2(),
          this.cos2()
        );
      }
    }
    return this._bisector_vec;
  }

  from_line() {
    if (!this._from_line) {
      this._from_line = new Line(this._via, this._from);
    }
    return this._from_line;
  }

  to_line() {
    if (!this._to_line) {
      this._to_line = new Line(this._via, this._to);
    }
    return this._to_line;
  }

  AD() {
    if (!this._AD) {
      this._AD = Math.min(this._vec_from.length(), this._vec_to.length());
    }
    return this._AD;
  }

  AO() {
    if (!this._AO) {
      if (this._AC) {
        this._AO = this._AC + this.get_circle_radius();
      } else {
        this._AO = Math.sqrt(
          this.get_circle_radius() * this.get_circle_radius() +
            this.AD() * this.AD()
        );
      }
    }
    return this._AO;
  }

  sin2() {
    if (!this._sin2) {
      this._sin2 = Math.sin(this.angle() / 2);
    }
    return this._sin2;
  }

  cos2() {
    if (!this._cos2) {
      this._cos2 = Math.cos(this.angle() / 2);
    }
    return this._cos2;
  }

  tan2() {
    if (!this._tan2) {
      this._tan2 = this.sin2() / this.cos2();
    }
    return this._tan2;
  }

  get_circle_radius() {
    if (!this._radius) {
      if (this._AC !== null) {
        const b = this._AC * Math.abs(this.sin2());
        if (this._AC === b) {
          this._radius = this._AC;
        } else {
          this._radius = (this._AC * b) / (this._AC - b);
        }
      } else {
        if (this._modifier === 0) {
          this._radius = 5;
        } else {
          this._radius = this.tan2() * this.AD();
        }
      }
    }
    return this._radius;
  }

  get_circle_center() {
    if (!this._circle_center_point) {
      if (this._modifier === 0) {
        const x =
          this._via.x +
          this.get_circle_radius() *
            (this.from_line()
              .directing_vector()
              .x() -
              this.from_line()
                .normal_vector()
                .x());
        const y =
          this._via.y +
          this.get_circle_radius() *
            (this.from_line()
              .directing_vector()
              .y() -
              this.from_line()
                .normal_vector()
                .y());
        this._circle_center_point = { x: x, y: y };
      } else {
        this._circle_center_point = {
          x: this._via.x + this.bisector_vec().x() * this.AO(),
          y: this._via.y + this.bisector_vec().y() * this.AO()
        };
      }
    }
    return this._circle_center_point;
  }

  generate_geom(point_number = 10) {
    this._points = [];
    if (this._modifier === 4) {
      this._points.push([this.from().x, this.from().y]);
      this._points.push([this.to().x, this.to().y]);
    } else {
      const point = this.get_circle_center();
      let mini_angle =
        (-this.cross_product_sign() * (Math.PI - Math.abs(this.angle()))) /
        point_number;

      let temp_val =
        -(this.angle() / Math.abs(this.angle())) * this.cross_product_sign();
      if (this.modifier() === 0) {
        temp_val = 1;
        mini_angle = Math.abs(mini_angle);
      }
      const sin = Math.sin(mini_angle);
      const cos = Math.cos(mini_angle);
      let vec = this._vec_from.get_rotated(null, temp_val, 0);

      this._points.push([this.from().x, this.from().y]);
      for (let i = 0; i < point_number + 1; i++) {
        this._points.push([
          point.x + vec.x() * this.get_circle_radius(),
          point.y + vec.y() * this.get_circle_radius()
        ]);
        vec = vec.get_rotated(null, sin, cos);
      }
      if (this._modifier === 0) {
        this._points.push([
          this.from().x -
            this.from_line()
              .normal_vector()
              .x() *
              2 *
              this.get_circle_radius(),
          this.from().y -
            this.from_line()
              .normal_vector()
              .y() *
              2 *
              this.get_circle_radius()
        ]);
      } else if (this._vec_from.length() < this._vec_to.length()) {
        this._points.push([this.to().x, this.to().y]);
      }
    }
    return this._points;
  }

  geom() {
    return this._points;
  }

  set_vec_offset(vec, val = 0) {
    if (val !== 0) {
      vec = new Vector(vec.x() * val, vec.y() * val);
    }
    for (let i = 0; i < this._points.length; i++) {
      this._points[i][0] = this._points[i][0] + vec.x();
      this._points[i][1] = this._points[i][1] + vec.y();
    }
    return this._points;
  }
}
